import { createEnv } from '@t3-oss/env-core';
// import 'dotenv/config';
import { z } from 'zod';

export const isProduction = import.meta.env.NODE_ENV === 'production';
export const isTesting = import.meta.env.NODE_ENV === 'test';

export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_API_ENTRYPOINT: z.string().url().min(10).max(1000),
    VITE_TOKEN: z.string().min(10).max(1000),
  },
  runtimeEnv: {
    VITE_API_ENTRYPOINT: import.meta.env.VITE_API_ENTRYPOINT,
    VITE_TOKEN: import.meta.env.VITE_TOKEN,
  },
});
